import React from 'react';
import { createPortal } from 'react-dom';
import styled from '@xstyled/styled-components';
import { BurgerButton } from '~/ui/buttons/BurgerButton';
import { TrainingState, useTrainingStore } from '../state';
import { select } from '~/lib/select';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';

const Button = styled(BurgerButton)`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: hud;
  &:hover {
    transform: scale(1.1);
  }
  @media ((max-width: 580px) and (max-height: 300px)) {
    left: 10px;
  }
`;

const selector = (s: TrainingState) =>
  select(s, 'toggleNav', 'activeItemPosition');

const mediaSelector = (s: MediaPlayerStore) => select(s, 'pause');

export const OpenNavigationButton = () => {
  const { toggleNav, activeItemPosition } = useTrainingStore(selector);
  const { pause } = useMediaPlayerStore(mediaSelector);

  const onClick = () => {
    try {
      pause();
    } catch (error) {
      // Silently ignore media player errors
    }
    toggleNav();
  };

  return createPortal(
    <Button
      onClick={onClick}
      tabIndex={0}
      data-test-id="training-navigation-burger-button"
    >
      {Math.floor(activeItemPosition / 10000)}
    </Button>,
    document.getElementById('root')!
  );
};
